module.exports = __webpack_public_path__ + "img/product_category_preview_image-5.aef0366.webp";